import axios from "axios";

const middlewareHttpClient = axios.create({
  baseURL: process.env.MIDDLEWARE_URL || "",
});

export const marcarComoLidas = async (
  ids: number[],
  accessToken: string
): Promise<boolean> => {
  let result = false;
  await middlewareHttpClient
    .post("/notificacoes/lida", ids, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "app-key": process.env.APP_KEY || "",
      },
    })
    .then((response) => {
      result = true;
    })
    .catch((error) => {
      result = false;
    });

  return result;
};

export const arquivar = async (accessToken: string): Promise<boolean> => {
  let result = false;
  await middlewareHttpClient
    .post(
      "/notificacoes/mensagem/arquivar",
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "app-key": process.env.APP_KEY || "",
        },
      }
    )
    .then((response) => {
      result = true;
    })
    .catch((error) => {
      result = false;
    });

  return result;
};
